import { buildLoginRedirectUrl } from "@knowfully/ui.common";
import useGlobalContext from "hooks/globalData";
import { useEffect } from "react";
import {
  AuthenticationResponse,
  ResponseCode,
  ResponseOfAuthenticationResponse,
} from "services/KnowfullyAdminClient";
import authStore, {
  clearAuthState,
  getPersistedAuthState,
  saveAuthState,
} from "stores/authStore";
import { ClaimType, UserClaim } from "types/claimTypes";

const LoginPage = () => {
  const { authenticationService } = useGlobalContext();

  useEffect(() => {
    async function CheckAuthentication() {
      const userResponseRaw: ResponseOfAuthenticationResponse = await authenticationService.getAuthenticationResponse();
      if (
        userResponseRaw.responseCode === ResponseCode.OK &&
        userResponseRaw.data?.result
      ) {
        const userResponse = userResponseRaw.data;

        createUserClaim(userResponse);

        const userData = getPersistedAuthState();

        authStore.update((s) => {
          s.isLoggedIn = true;
          s.firstName = userData?.firstName;
          s.lastName = userData?.lastName;
          s.claims = userData?.claims ?? [];
        });
      } else {
        clearAuthState();
        window.location.replace(
          buildLoginRedirectUrl(
            `${window.location.pathname}${window.location.search}`
          )
        );
      }
    }

    CheckAuthentication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createUserClaim = (userResponse: AuthenticationResponse) => {
    const claims = userResponse.permissions?.map((perm: string) => {
      try {
        const splitted = perm.split(".");

        return {
          claimType: ClaimType.Permission,
          parentClaim: splitted[0],
          claimResource: splitted[1],
          claimPermission: splitted[2],
        } as UserClaim;
      } catch {
        console.log("There are permissions not properly processed.");
        // eslint-disable-next-line array-callback-return
        return;
      }
    });

    saveAuthState({
      id: userResponse.id ?? null,
      email: userResponse.email,
      firstName: userResponse.firstName,
      lastName: userResponse.lastName,
      isLoggedIn: true,
      claims: claims ?? [],
    });
  };

  return <></>;
};

export default LoginPage;
